import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ControlUser } from '../model/controlUser';
import { UserService } from '../service/user.service';
import { Overlay } from "@angular/cdk/overlay";
import { Log } from '../util/log';
import { AliasOwnerRel } from '../model/AliasOwnerRel';
import { LinkAliasDialogComponent } from '../link-alias-dialog/link-alias-dialog.component';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-aliases',
  templateUrl: './aliases.component.html',
  styleUrls: ['./aliases.component.css']
})
export class AliasesComponent implements OnInit {

  @ViewChild('aliasestable', { static: true }) table;
  @ViewChild('aliasesloader', { static: true }) loader;
  @ViewChild(MatSort) sort: MatSort;

  @Output() selected = new EventEmitter<AliasOwnerRel>();
  selectedUser: AliasOwnerRel;
  selectedRow: number;

  aliases: AliasOwnerRel[];
  dataSource: MatTableDataSource<AliasOwnerRel>;

  backgroundImage: string = "";
  showBackGroundImage: string[] = ["questura@pilomat.com", "questura1@pilomat.com", "gestore@1control.it", "gestore@pilomat.com"];

  canUserEditAlias: boolean = false;
  amIAlias: boolean = false;

  displayedColumns: string[] = [
    'alias.email',
    'publicName',
    'unlinkAlias'
  ];

  constructor(
    private appComponent: AppComponent,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private router: Router,
    private overlay: Overlay) {

  }

  ngOnInit(): void {
  }


  async ngAfterViewInit() {
    this.checkPermissions();

    this.getUserEmail();
    this.getAliases();
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  async checkPermissions() {
    const isAlias = await this.appComponent.isAlias();
    if (isAlias) {
      this.canUserEditAlias = await this.checkAliasPermissions("AliasEdit");
      this.amIAlias = true;
    } else {
      this.canUserEditAlias = true;
    }
  }

  async checkAliasPermissions(feature: string): Promise<boolean> {
    return this.userService.checkAliasPermissions(feature);
  }

  onKey(event: any) {
    let filterString = event.target.value;
    this.table.dataSource.filter = filterString.trim().toLowerCase();
  }

  filterTable(data: AliasOwnerRel, filter: string): boolean {
    if (data.alias.email && data.alias.email.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    return false;
  }

  getAliases() {
    this.loader.showLoading();

    const obs = this.userService.getOwnerAliases(this.userService.meUser.uid);
    obs.subscribe(data => {

      // se l'utente loggato è un alias, lo rimuovo dall'elenco altrimenti potrebbe modificare i propri permessi
      if (this.amIAlias) {
        data = data.filter(user => user.aliasUid !== this.userService.meAliasUser.aliasUid);
      }
      
      this.aliases = data;

      this.table.dataSource = new MatTableDataSource(this.aliases);
      this.table.dataSource.filterPredicate = this.filterTable;
      this.table.dataSource.sort = this.sort;

      this.loader.hideLoading();

    }, error => {

      this.loader.hideLoading();
      this.loader.showError();
    });
    this.loader.hideLoading();
  }

  addAlias() {

    Log.debug('clicked addAlias ');

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(LinkAliasDialogComponent, {
      width: "950px",
      data: { ownerUid: this.userService.meUser.uid },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        if (response == "Success") {
          window.location.reload();
        }
      }
    });
  }



  getUserEmail() {
    this.userService.getFirebaseUserObs().subscribe(firebaseUser => {
      this.userService.getMe().subscribe(user => {
        if (this.showBackGroundImage.includes(user.email)) {
          this.backgroundImage = "url('assets/img/Banner_pconnect_Milano_day.jpg')";
        } else {
          this.backgroundImage = "unset"
        }
      }, errorRes => {
        Log.debug("error cannot retrieve user ");
      });
    }, errorRes => {
      Log.debug("error cannot retrieve user ");
    });
  }

  unlinkOwner(alias) {
    let message = $localize`:@@aliases_confirm_unlink:Desideri scollegare l'operatore?`;
    let confirmMessage = $localize`:@@aliases_confirmat:Conferma`;
    let cancelMessage = $localize`:@@aliases_cancel:Annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "350px",
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        this.userService.unlinkAliasFromOwner(alias.id).subscribe(data => {
          Log.debug(data);
          window.location.reload();
        });
      }
    });
  }

  openAliasDetailPage(alias) {
    this.selectedRow = alias.id;

    this.router.navigate(['alias/' + alias.id]);

    this.cdRef.detectChanges();
  }


  onRowClicked(row) {
    // this.selectedRow = row.id;

    // this.router.navigate(['alias/' + row.id]);

    // this.cdRef.detectChanges();
  }
}
